import { useQuery } from '@tanstack/react-query';
import { getClientAllUsers } from '../../../../services/tickets/admin';

export const clientUsersQueryKeys = {
  byClient: (clientId) => ['adminClientUsers', clientId],
};

const normalizeUsers = (response) => {
  const list = response?.users ?? response?.data ?? (Array.isArray(response) ? response : []);
  return list.map((user) => ({
    id: user._id ?? user.id,
    name: user.username ?? user.fullName ?? user.email ?? 'Unnamed user',
  }));
};

export function useClientUsersQuery(clientId) {
  return useQuery({
    queryKey: clientUsersQueryKeys.byClient(clientId),
    queryFn: () => getClientAllUsers({ clientId, mode: 'ALL' }),
    select: normalizeUsers,
    enabled: Boolean(clientId), // never fires until a client is picked
    staleTime: 30_000, // 30s cache time
  });
}
